export type SearchFiltersOptions = {
  productType?: string;
  indexName?: string;
  excludeOnlyArchivedCourseRuns?: boolean;
};

export const onlyArchivedCourseRunsExclusion = (
  excludeOnlyArchivedCourseRuns: boolean,
): string =>
  excludeOnlyArchivedCourseRuns ? " AND NOT onlyArchivedCourseRuns:true" : "";
